import type { CurrentLegalDocuments, LegalConsentDecision, LegalDocument } from '../types'

export function legalConsentInputName(document: LegalDocument): string {
  return `legalConsent:${encodeURIComponent(document.serviceCode)}:${encodeURIComponent(document.consentCode)}:${encodeURIComponent(document.documentVersion)}`
}

export function legalDocumentsForEnrollment(
  documents: CurrentLegalDocuments,
  includeCommon: boolean,
): LegalDocument[] {
  return includeCommon
    ? [...documents.commonDocuments, ...documents.serviceDocuments]
    : [...documents.serviceDocuments]
}

export function legalDocumentsUsable(documents: LegalDocument[]): boolean {
  return documents.length > 0
    && documents.every((document) => document.contentAvailable
      && Boolean(document.content?.trim())
      && Boolean(document.locale?.trim())
      && Number.isInteger(document.translationRevision)
      && document.translationRevision > 0)
}

export function legalConsentDecisions(
  form: FormData,
  documents: LegalDocument[],
): LegalConsentDecision[] {
  return documents.map((document) => ({
    serviceCode: document.serviceCode,
    consentCode: document.consentCode,
    documentVersion: document.documentVersion,
    agreed: form.get(legalConsentInputName(document)) === 'on',
    displayLocale: document.locale,
    translationRevision: document.translationRevision,
    addendumRefs: document.addenda.map((addendum) => ({
      jurisdictionCode: addendum.jurisdictionCode,
      addendumVersion: addendum.addendumVersion,
      locale: addendum.locale,
      translationRevision: addendum.translationRevision,
      contentSha256: addendum.contentSha256,
    })),
  }))
}
